import React from 'react';

import {DashboardWidget} from 'app/components/Dashboard/DashboardWidget';

import cs from './MultiFeatureAnalysisSkeleton.styl';

export const MultiFeatureAnalysisSkeleton: React.FC = () => {
  return (
    <DashboardWidget title={<span className="bp5-skeleton">Loading Analysis</span>} size="small">
      <div className={cs.skeletonLoader} />
    </DashboardWidget>
  );
};
